<header aria-label="Header" class="header">
  <p-button-pure
    [class]="navbarOpenerClass"
    [iconSource]="'assets/icons/menu-lines.svg'"
    (click)="toggleNavbar()"
  >
    Menu
  </p-button-pure>
</header>
